/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { fetchTeams } from "../fetchData";
import { Toast } from "primereact/toast";
import {} from "../../../../helper/DateConverters";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../../../util/roleNameConstants";
import HsDashBoardCardBG from "../../../../assets/images/hs-dashboard-card-bg.png";

const RiskAssessmentDashboard = ({ date, setDate }: any) => {
  const toast = useRef<Toast>(null);

  const navigate = useNavigate();

  const [teamsList, setTeamsList] = useState<any>([]);
  const [teamsListLoading, setTeamsListLoading] = useState<boolean>(false);
  const [expandedTeam, setExpandedTeam] = useState<string | null>(null);
  // const [date, setDate] = useState<any>(() => {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   return convertDateToEpochUTC(today);
  // });
  const [selectedTeam, setSelectedTeam] = useState<string | null>("All Teams");

  useEffect(() => {
    if (!localStorage.roleName?.includes(ROLES.HANDS_ADMIN)) {
      navigate(localStorage.currentModuleUrl || "/");
      // window.location.href = localStorage.currentModuleUrl || "/";
    }
  }, []);

  useEffect(() => {
    fetchTeams(setTeamsList, setTeamsListLoading, null, date);
  }, [date]);

  const toggleTeam = (teamName: string) => {
    setExpandedTeam(expandedTeam === teamName ? null : teamName);
  };

  // Calculate summary data for cards and combine all users
  const calculateSummary = () => {
    let allTeams = {
      submitted: 0,
      notSubmitted: 0,
      total: 0,
      allSubmittedUsers: [] as any[],
      allNotSubmittedUsers: [] as any[],
    };
    const teamSummaries: Record<string, any> = {};
    const submittedUsersMap = new Map<
      string,
      {
        userID: any;
        userEmail: any;
        displayName: any;
        teamNames: Set<string>;
      }
    >();
    const notSubmittedUsersMap = new Map<
      string,
      {
        userID: any;
        userEmail: any;
        displayName: any;
        teamNames: Set<string>;
      }
    >();

    teamsList.forEach((team: any) => {
      const notSubmittedUsers = team.teamUsers.filter(
        (u: any) => u.isUserAvailable,
      );
      const submittedUsers = team.teamUsers.filter(
        (u: any) => !u.isUserAvailable,
      );

      team.teamUsers.forEach((user: any) => {
        const userKey = `${user.userID || user.userEmail}`;
        const targetMap = user.isUserAvailable
          ? notSubmittedUsersMap
          : submittedUsersMap;
        const existing = targetMap.get(userKey);

        if (existing) {
          existing.teamNames.add(team.teamName);
        } else {
          targetMap.set(userKey, {
            userID: user.userID,
            userEmail: user.userEmail,
            displayName: user.displayName,
            teamNames: new Set([team.teamName]),
          });
        }
      });

      teamSummaries[team.teamName] = {
        submitted: submittedUsers.length,
        notSubmitted: notSubmittedUsers.length,
        total: team.teamUsers.length,
        submittedUsers,
        notSubmittedUsers,
      };
    });

    const allNotSubmittedUsers = Array.from(notSubmittedUsersMap.values()).map(
      (user) => ({
        ...user,
        teamNames: Array.from(user.teamNames).sort(),
      }),
    );

    const allSubmittedUsers = Array.from(submittedUsersMap.values()).map(
      (user) => ({
        ...user,
        teamNames: Array.from(user.teamNames).sort(),
      }),
    );

    const allUsersTotal = new Set(
      Array.from(notSubmittedUsersMap.keys()).concat(
        Array.from(submittedUsersMap.keys()),
      ),
    );

    allTeams = {
      submitted: allSubmittedUsers.length,
      notSubmitted: allNotSubmittedUsers.length,
      total: allUsersTotal.size,
      allSubmittedUsers,
      allNotSubmittedUsers,
    };

    return {
      allTeams,
      teamSummaries,
    };
  };

  const { allTeams, teamSummaries } = calculateSummary();

  // Handle card click
  const handleCardClick = (teamName: string) => {
    setSelectedTeam(teamName);
    if (teamName !== "All Teams") {
      setExpandedTeam(teamName);
    } else {
      setExpandedTeam(null);
    }
  };

  const teamCards = [
    { teamID: "all", teamName: "All Teams" },
    ...teamsList.map((team: any) => ({
      teamID: team.teamID,
      teamName: team.teamName,
    })),
  ];

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-space-y-6">
        {/* Dashboard Header */}
        <div className="tw-w-full">
          {/* Mobile layout (stacked) */}
          <div className="tw-flex tw-flex-col tw-gap-4 md:tw-hidden tw-mb-6">
            <div>
              <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800">
                Risk Assessment Dashboard
              </h1>
              <p className="tw-text-gray-500">
                Team submission status overview
              </p>
            </div>
          </div>

          {/* Desktop layout (side by side) */}
          <div className="tw-hidden md:tw-flex tw-justify-between tw-items-start tw-mb-6">
            <div>
              {/* <h1 className="tw-text-xl tw-font-bold tw-text-gray-800">
                Risk Assessment Dashboard
              </h1> */}
              {/* <p className="tw-text-gray-500">
                Team submission status overview
              </p> */}
            </div>
          </div>
        </div>

        {/* Summary Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4">
          {teamCards.map((team: any) => {
            const isAllTeams = team.teamName === "All Teams";
            const summary = isAllTeams
              ? allTeams
              : teamSummaries[team.teamName] || {
                  submitted: 0,
                  notSubmitted: 0,
                  total: 0,
                };

            return (
              <div
                key={team.teamID}
                className={`tw-border tw-rounded-lg tw-p-4 tw-cursor-pointer tw-transition-all ${
                  selectedTeam === team.teamName
                    ? "tw-border-blue-500 tw-bg-blue-50"
                    : "tw-border-gray-200 hover:tw-bg-gray-50"
                }`}
                onClick={() => handleCardClick(team.teamName)}
                style={{
                  backgroundImage: `url(${HsDashBoardCardBG})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <h3 className="tw-font-medium tw-text-gray-800">
                  {team.teamName}
                </h3>
                <div className="tw-mt-2 tw-flex tw-justify-between">
                  <div>
                    <p className="tw-text-sm tw-text-gray-500">Total Members</p>
                    <p className="tw-text-xl tw-font-bold">{summary.total}</p>
                  </div>
                  <div className="tw-space-y-1">
                    <p className="tw-text-lg tw-text-green-600">
                      ✓ {summary.submitted}
                    </p>
                    <p className="tw-text-lg tw-text-yellow-600">
                      ✗ {summary.notSubmitted}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Team Cards */}
        {teamsListLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50 tw-ml-6 tw-mr-2">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="tw-space-y-4">
            {selectedTeam === "All Teams" ? (
              // Show combined table for all teams with internal scrolling
              <div className="tw-border tw-border-gray-200 tw-rounded-lg tw-overflow-hidden tw-bg-white tw-max-h-[calc(100vh-300px)] tw-overflow-y-auto">
                <div className="tw-p-4 tw-bg-gray-50 tw-sticky tw-top-0 tw-z-10">
                  <h3 className="tw-font-medium tw-text-gray-800 tw-text-lg tw-mb-4">
                    All Teams Summary
                  </h3>
                  <div className="tw-flex tw-gap-4 tw-mt-2">
                    <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-yellow-100 tw-text-yellow-800">
                      {allTeams.notSubmitted} Not Submitted
                    </span>
                    <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-green-100 tw-text-green-800">
                      {allTeams.submitted} Submitted
                    </span>
                  </div>
                </div>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-p-4">
                  {/* Not Submitted Users Column */}
                  <div>
                    {/* <h4 className="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-3 tw-flex tw-items-center tw-sticky tw-top-16 tw-bg-gray-50 tw-py-2 tw-z-10">
                      <span className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-yellow-500 tw-mr-2"></span>
                      Not Submitted ({allTeams.notSubmitted})
                    </h4> */}
                    <div className="tw-space-y-2">
                      {allTeams.allNotSubmittedUsers.length > 0 ? (
                        allTeams.allNotSubmittedUsers.map(
                          (user: any, index) => (
                            <div
                              key={index}
                              className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-yellow-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                            >
                              <div>
                                <div className="tw-font-medium tw-text-gray-800">
                                  {user.displayName}
                                </div>
                                <div className="tw-text-xs tw-text-gray-500">
                                  Team: {user.teamNames.join(", ")}
                                </div>
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                          All assessments submitted
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Submitted Users Column */}
                  <div>
                    {/* <h4 className="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-3 tw-flex tw-items-center tw-sticky tw-top-16 tw-bg-gray-50 tw-py-2 tw-z-10">
                      <span className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-green-500 tw-mr-2"></span>
                      Submitted Assessments ({allTeams.submitted})
                    </h4> */}
                    <div className="tw-space-y-2">
                      {allTeams.allSubmittedUsers.length > 0 ? (
                        allTeams.allSubmittedUsers.map((user: any, index) => (
                          <div
                            key={index}
                            className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-green-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                          >
                            <div>
                              <div className="tw-font-medium tw-text-gray-800">
                                {user.displayName}
                              </div>
                              <div className="tw-text-xs tw-text-gray-500">
                                Team: {user.teamNames.join(", ")}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                          No submissions yet
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Show team-specific tables when a specific team card is clicked
              teamsList
                .filter(
                  (team: any) =>
                    selectedTeam === "All Teams" ||
                    team.teamName === selectedTeam,
                )
                .map((team: any) => {
                  const notSubmittedUsers = team.teamUsers.filter(
                    (u: any) => u.isUserAvailable,
                  );
                  const submittedUsers = team.teamUsers.filter(
                    (u: any) => !u.isUserAvailable,
                  );
                  const isExpanded =
                    expandedTeam === team.teamName ||
                    selectedTeam === team.teamName;

                  return (
                    <div
                      key={team.teamName}
                      className="tw-border tw-border-gray-200 tw-rounded-lg tw-overflow-hidden tw-bg-gra-50 tw-max-h-[calc(100vh-300px)] tw-overflow-y-auto"
                    >
                      <div
                        className="tw-flex tw-justify-between tw-items-center tw-p-4 tw-cursor-pointer hover:tw-bg-gray-50 tw-sticky tw-top-0 tw-bg-gray-50 tw-z-10"
                        onClick={() => toggleTeam(team.teamName)}
                      >
                        <div>
                          <h3 className="tw-font-medium tw-text-gray-800 tw-text-lg">
                            {team.teamName}
                          </h3>
                          <div className="tw-flex tw-gap-4 tw-mt-2">
                            <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-yellow-100 tw-text-yellow-800">
                              {notSubmittedUsers.length} Not Submitted
                            </span>
                            <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-green-100 tw-text-green-800">
                              {submittedUsers.length} Submitted
                            </span>
                          </div>
                        </div>
                      </div>

                      {isExpanded && (
                        <div className="tw-border-t tw-border-gray-200 tw-p-4 tw-bg-white">
                          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                            {/* Not Submitted Users Column */}
                            <div>
                              <h4 className="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-3 tw-flex tw-items-center">
                                <span className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-yellow-500 tw-mr-2"></span>
                                Not Submitted
                              </h4>
                              <div className="tw-space-y-2">
                                {notSubmittedUsers.length > 0 ? (
                                  notSubmittedUsers.map((user: any) => (
                                    <div
                                      key={user.id}
                                      className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-yellow-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                                    >
                                      <div>
                                        <div className="tw-font-medium tw-text-gray-800">
                                          {user.displayName}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                                    All assessments submitted
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Submitted Users Column */}
                            <div>
                              <h4 className="tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-3 tw-flex tw-items-center">
                                <span className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-green-500 tw-mr-2"></span>
                                Submitted Assessments
                              </h4>
                              <div className="tw-space-y-2">
                                {submittedUsers.length > 0 ? (
                                  submittedUsers.map(
                                    (user: any, index: any) => (
                                      <div
                                        key={index}
                                        className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-green-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                                      >
                                        <div>
                                          <div className="tw-font-medium tw-text-gray-800">
                                            {user.displayName}
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                ) : (
                                  <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                                    No submissions yet
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default RiskAssessmentDashboard;
